import { Alert, CircularProgress, Modal, Snackbar, Box, FormControl, InputLabel, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { style as modalStyle } from "../../../components/Loading/Loading";
import { WhiteInput } from "../../../components/Inputs/InputText";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import servEquipamentos from "../../../services/login/servEquipamentos";
import styles from "./ConsultarHomologacao.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClose, faInfoCircle, faPen, faSpinner } from "@fortawesome/free-solid-svg-icons";


const ConsultarHomologacao = ({ setOpenPopup, recordForEdit, pesquisar }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [openErrorWindow, setOpenErrorWindow] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [equipamento, setEquipamento] = useState(null);
    const [situacaoEquipTexto, setSituacaoEquipTexto] = useState("");

    const handleCloseError = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenErrorWindow(false);
        }

        setOpenErrorWindow(false);
    }

    useEffect(() => {
        const recuperarEquipamento = async () => {
            try {
                setIsLoading(true);
                
                let dados = await servEquipamentos.RecuperarPrazosEquipamento(recordForEdit?.Id || recordForEdit?.row?.id);
                
                setIsLoading(false);
                
                formataValores(dados.Content);
                
                setEquipamento(dados.Content);
            } catch (err) {
                setIsLoading(false);
                setErrorMessage(err.Message);
                setOpenErrorWindow(true);
            }
        }

        recuperarEquipamento();
    }, []);

    const formataValores = (dados) => {
        formataSituacaoParaTexto(dados.Situacao);
    }

    const formataSituacaoParaTexto = (situacao) => {
        let txtSituacao = "";

        switch(situacao) {
            case 0:
                txtSituacao = "Em digitação";
                break;
            case 1:
                txtSituacao = "Pendente de homologação";
                break;
            case 2:
                txtSituacao = "Revisar cadastro";
                break;
            case 3:
                txtSituacao = "Homologado";
                break;
            case 4:
                txtSituacao = "Cancelado";
                break;
            default: 
                txtSituacao = "Em digitação";
                break;
        }

        setSituacaoEquipTexto(txtSituacao);
    }
    
    return (
        <div style={{ width: "100%", minWidth: 580, maxWidth: 580, height: "100%" }}>
            { (equipamento !== null && equipamento.Id !== 0) && (
                <div>
                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={styles.dateBox}></div><b>Data de cadastro: </b> {
                                equipamento?.DataCadastro?.includes("01/01/1900") || equipamento?.DataCadastro?.includes("01/01/0001") ?
                                    "Data ainda não definida" :
                                    format(parse(equipamento?.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                        locale: ptBR
                                    })
                            }
                        </span>
                    </header>

                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={`${styles.dateBox} ${styles['dateBox-green']}`}></div><b>Data de envio para homologação: </b> {
                                equipamento?.CadastradoPorAnalista ?
                                    equipamento?.DataCadastro?.includes("01/01/1900") || equipamento?.DataCadastro?.includes("01/01/0001") ?
                                        "Data ainda não definida" :
                                        format(parse(equipamento?.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                            locale: ptBR
                                        }) :
                                    equipamento?.DataEnvioHomologacao?.includes("01/01/1900") || equipamento?.DataEnvioHomologacao?.includes("01/01/0001") ?
                                        "Data ainda não definida" :
                                        format(parse(equipamento?.DataEnvioHomologacao, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                            locale: ptBR
                                        })
                            }
                        </span>
                    </header>

                    <header className={styles.header}>
                        <span className={styles.headerData}>
                            <div className={`${styles.dateBox} ${styles['dateBox-orange']}`}></div><b>Data de prazo da análise: </b>{
                                equipamento?.CadastradoPorAnalista ?
                                    equipamento?.DataCadastro?.includes("01/01/1900") || equipamento?.DataCadastro?.includes("01/01/0001") ?
                                        "Data ainda não definida" :
                                        format(parse(equipamento?.DataCadastro, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                            locale: ptBR
                                        }) :
                                    equipamento?.DataPrazoAnalise?.includes("01/01/1900") || equipamento?.DataPrazoAnalise?.includes("01/01/0001") ?
                                        "Data ainda não definida" :
                                        format(parse(equipamento?.DataPrazoAnalise, 'dd/MM/yyyy HH:mm:ss', new Date()), "dd 'de' MMMM 'de' yyyy", {
                                            locale: ptBR
                                        })
                            }
                        </span>
                    </header>
                </div>
            )}
            <div className={styles.situacaoEquip}>
                <div className={
                    equipamento?.Situacao === 0
                    ? `${styles.resultadoEquipParcial} + ${styles.EmDigitacao}`
                    : equipamento?.Situacao === 1
                    ? `${styles.resultadoEquipParcial} + ${styles.PendenteHomologacao}`
                    : equipamento?.Situacao === 2
                    ? `${styles.resultadoEquipParcial} + ${styles.RevisarCadastro}`
                    : equipamento?.Situacao === 3
                    ? `${styles.resultadoEquipParcial} + ${styles.Homologado}`
                    : `${styles.resultadoEquipParcial} + ${styles.Cancelada}`
                }>
                    <h3>Resultado</h3>
                    <div className={styles.parecerSituacaoEquip}>
                        Situação: {
                            situacaoEquipTexto
                        }
                        <p>
                            <FontAwesomeIcon
                                size="lg"
                                icon={
                                    equipamento?.Situacao === 0
                                    ? faPen
                                    : equipamento?.Situacao === 1
                                    ? faSpinner
                                    : equipamento?.Situacao === 2
                                    ? faInfoCircle
                                    : equipamento?.Situacao === 3
                                    ? faCheck
                                    : faClose
                                }
                            />
                        </p>
                    </div>
                </div>
            </div>

            { (equipamento?.Situacao === 2) && (
                <div className={styles.descricao}>
                    <strong style={{ display: "block" }}>Motivo da revisão:</strong>
                    <FormControl variant="outlined" style={{ width: "100%" }}>
                        <WhiteInput 
                            style={{ color: "#B8B8B8" }}
                            fullWidth
                            type="text"
                            minRows={4}
                            multiline
                            value={equipamento?.MotivoRevisao}
                            readOnly={true}
                        />
                    </FormControl>
                </div>
            )}

            { (equipamento?.Situacao === 4) && (
                <div className={styles.descricao}>
                    <strong style={{ display: "block" }}>Motivo do cancelamento:</strong>
                    <FormControl variant="outlined" style={{ width: "100%" }}>
                        <WhiteInput 
                            style={{ color: "#B8B8B8" }}
                            fullWidth
                            type="text"
                            minRows={4}
                            multiline
                            value={equipamento?.MotivoCancelamento}
                            readOnly={true}
                        />
                    </FormControl>
                </div>
            )}

            <div style={{
                margin: "25px 40px",
                display: "flex",
                justifyContent: "flex-end",
                gap: "20px"
            }}>
                <BlueHoverButton onClick={() => setOpenPopup(false)}>Fechar</BlueHoverButton>
            </div>

            <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}> 
                    <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
                        {errorMessage}
                    </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalStyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    );
}

export { ConsultarHomologacao };